// Routes redesigned in the about group. Each entry: { path, element }.
// Entries here override the legacy routes in App.jsx for the same path.
import AboutPage from "./AboutPage.jsx";
import JourneyPage from "./JourneyPage.jsx";
import TeamPage from "./TeamPage.jsx";
import ImpactPage from "./impact/ImpactPage.jsx";
import PartnershipsPage from "./PartnershipsPage.jsx";
import GovernancePage from "./GovernancePage.jsx";

export const routes = [
  { path: "/about", element: <AboutPage /> },
  { path: "/journey", element: <JourneyPage /> },
  { path: "/team", element: <TeamPage /> },
  { path: "/impact", element: <ImpactPage /> },
  { path: "/partnerships", element: <PartnershipsPage /> },
  { path: "/governance", element: <GovernancePage /> },
];
